// Vercel Web Analytics — a cookieless pageview count per route, so the owner
// can see how many people are on the leaderboard and when (2026-10-16: while
// sizing the board for "a hundred" viewers the count turned out to be unknown;
// "Ok go ahead"). Every page entry calls startWebAnalytics() once after it
// mounts; the client is ~2 KB and tracks route changes on its own.
//
// It sends only from the sites themselves — raisedbeef.com, raisedbeef.ai and
// Vercel previews. Not from localhost, not from the native barn apps (a
// Capacitor shell is not a website), and never under the test runner.
//
// ⚠️ THE DASHBOARD SIDE IS A SWITCH THE OWNER FLIPS: Vercel → the project →
// Analytics → Enable. Until then the client posts and Vercel discards; nothing
// here breaks either way.

import { inject } from "@vercel/analytics";

import { startMetaPixel } from "./metaPixel";

/** The hosts whose pageviews count. Exported for the test. */
export function shouldCount(hostname: string, mode: string): boolean {
  if (mode === "test") return false;
  const h = hostname.toLowerCase();
  return h === "raisedbeef.com" || h.endsWith(".raisedbeef.com")
    || h === "raisedbeef.ai" || h.endsWith(".raisedbeef.ai")
    || h === "cattlemarketcentral.com" || h === "www.cattlemarketcentral.com"
    || h.endsWith(".vercel.app");
}

let started = false;

export function startWebAnalytics(): void {
  if (started || typeof window === "undefined") return;
  started = true;
  // Meta's ad pixel rides the same once-per-page start, behind its own host
  // list and the visitor's choice (src/lib/metaPixel.ts).
  startMetaPixel();
  if (!shouldCount(window.location.hostname, import.meta.env?.MODE ?? "")) return;
  try {
    inject({ mode: "production" });
  } catch {
    // Analytics is never worth an error on a cattleman's screen.
  }
}
